<template>
  <AppHeader :action="{text: 'Add', route: 'ShopLogsCreate'}">Shop Logs</AppHeader>

  <Loading v-if="state == 'loading'"></Loading>

  <div v-if="state == 'idle'" class=" p-3">
      <div v-if="list.length" class="mt-5 responsive-table">
        <table>
          <thead>
            <tr>
              <th>ID</th>
              <th>Date</th>
              <th>Purpose</th>
              <th>Notes</th>
              <th>Image</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, i) in list" :key="i">
              <td>#{{ item.id }}</td>
              <td>{{ toDate(item.date) }}</td>
              <td>{{ item.type }}</td>
              <td><small>{{ item.notes }}</small></td>
              <td v-if="item.images.length"><a v-for="img in item.images" :key="img" :href="img.src" target="_blank" class="mr-2"><i class="icon ion-md-image"></i></a></td>
              <td v-else>-</td>
            </tr>
          </tbody>
        </table>
    </div>
    <div v-else>
      <p class="py-10 text-2xl text-center text-gray-400">No Data Found</p>
    </div>
  </div>

</template>

<script>
import AppHeader from '@/components/common/Header.vue';
import Loading from '@/components/common/Loading.vue';
import mixin from '@/utils/mixin';
import formMixin from '@/utils/mixins/form';

export default {
  name: 'ShopLogsIndex',
  mixins: [ mixin, formMixin ],
  components: { AppHeader, Loading},
  data() {
    return {
      state: 'loading',
      list: []
    }
  },

  methods: {
    getData() {
      this.state = 'loading';

      this.request('GET', 'shop-logs', {}, (resp) => {
        this.state = 'idle';
        if (resp.success) {
          this.list = resp.data;
        }
      });
    }
  },

  created() {
    this.getData();
  }
}
</script>
